<template>
  <div>
    <header>
      <div class="headerContainer_left">
        <div v-if="!hiddenCompany" class="company-name">
          <p class="font24">
            昌恩<span class="orangeTxt">智</span>控 节能项目投资回报预算系统
          </p>
        </div>
        <div v-else></div>
      </div>
      <div class="headerContainer_right">
        <i class="el-icon-setting" @click="resetPasswords"></i>
        <!-- <i class="el-icon-rank" @click="fullScreen"></i> -->
        <i class="iconfont icon-tuichu" @click="quit"></i>
        <!-- <i class="el-icon-setting" @click="theme"></i> -->
      </div>
    </header>

    <!-- theme -->
    <!--     <el-drawer
      title="Theme Customizer"
      size="16%"
      :visible.sync="drawer"
      :with-header="false"
    >
      <h3 class="t-a-l pd-tb20 font24 color-green">一键换肤</h3>
      <p class="line"></p>
      <p class="color-gray t-a-l font18 fw700">可选主题</p>
      <p class="line"></p>
      <div class="t-a-l" @input="checkedItem">
        <el-radio v-model="radio" label="light">Light</el-radio>
        <el-radio v-model="radio" label="dark">Dark</el-radio>
        <el-radio v-model="radio" label="default">Default</el-radio>
      </div>
      <p class="line"></p>
      <div class="custom" @input="checkedItem2">
        <el-radio class="color-gray font16" v-model="customRadio" label="custom"
          >自定义主题</el-radio
        >
        <el-color-picker
          v-model="color1"
          @active-change="customPeels"
        ></el-color-picker>
      </div>
      <p class="line"></p>
    </el-drawer> -->

    <!-- userInfo -->
    <userInfoDialog
      :visible="showUserInfoDialog"
      :title="title"
      width="30%"
      @closeDialog="closeDialog"
    >
      <el-form :model="changePwForm" ref="changePasswordForm">
        <el-form-item label="用户名称：" label-width="6.25rem" prop="userName">
          <el-input
            id="userName"
            type="userName"
            disabled
            v-model="changePwForm.userName"
            autocomplete="off"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="修改密码" prop="passWord">
          <el-input id="passWord" v-model="changePwForm.passWord"> </el-input>
        </el-form-item> -->

        <el-form-item
          label="修改密码："
          label-width="6.25rem"
          required
          :rules="[
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ]"
          prop="passWord"
        >
          <el-input
            placeholder="请输入新密码"
            prefix-icon="el-icon-lock"
            :type="eyeFlag ? 'text' : 'password'"
            class="passwordIcon"
            v-model.trim="changePwForm.passWord"
          >
            <i
              slot="suffix"
              class="font18"
              :class="[eyeFlag ? 'el-icon-view' : 'iconfont icon-biyanjing']"
              @click="eyeFlag = !eyeFlag"
            ></i>
          </el-input>
        </el-form-item>

        <el-form-item
          label="确认密码："
          label-width="6.25rem"
          required
          :rules="[
            { required: true, message: '请确认新密码', trigger: 'blur' },
            { validator: this.validateConfirm, trigger: 'blur' }
          ]"
          prop="reconfirmPassword"
        >
          <el-input
            placeholder="请确认新密码"
            prefix-icon="el-icon-lock"
            :type="eyeFlag2 ? 'text' : 'password'"
            class="passwordIcon"
            v-model.trim="changePwForm.reconfirmPassword"
          >
            <i
              slot="suffix"
              class="font18"
              :class="[eyeFlag2 ? 'el-icon-view' : 'iconfont icon-biyanjing']"
              @click="eyeFlag2 = !eyeFlag2"
            ></i>
          </el-input>
        </el-form-item>
        <!--  -->
        <el-form-item class="t-a-r">
          <el-button @click="cancelChange">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </userInfoDialog>
  </div>
</template>

<script>
import { setTheme } from '@/theme/theme'
import { extractRGBValues } from '@/utils/handlerRGB'
import { update } from '@/api/home/index'
import userInfoDialog from '@/components/elementComponents/dialog'
import userInfoForm from '@/components/elementComponents/form'

export default {
  name: 'headerPage',
  components: {
    userInfoDialog,
    userInfoForm
  },
  data () {
    return {
      eyeFlag: false,
      eyeFlag2: false,
      company_options: [],
      userName: '',
      projectValue: '',
      // area_options: [],
      areaValue: '',
      drawer: false,
      radio: '',
      customRadio: '',
      color1: '#409EFF',
      fullscreenFlag: false,
      bAntiShike: false,
      hiddenCompany: false,
      showUserInfoDialog: false,
      title: '',
      changePwForm: {
        userName: JSON.parse(localStorage.getItem('userInfo')).userName,
        passWord: '',
        reconfirmPassword: ''
      }
      // rules: {
      //   passWord: [
      //     { required: true, message: '密码不能为空' },
      //     { min: 6, max: 12, message: '长度在 6 到 12 个字符', trigger: 'blur' }
      //   ]
      // },
    }
  },
  beforeMount () {
    this.initTheme() //  初始化主题
    this.customTheme()
  },
  created () {},

  mounted () {
    // 监听window窗口变化 注册事件 -- 防抖
    window.onresize = () => {
      if (!this.bAntiShike) {
        this.bAntiShike = true
        setTimeout(() => {
          this.getWidth()
          this.bAntiShike = false
        }, 200)
      }
    }
  },
  beforeDestroy () {
    // 监听window窗口变化 事件注销
    window.onresize = null
  },
  computed: {},
  watch: {
    // authorityV2: {
    //   handler: function (newVal) {
    //     this.area_options = newVal
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    getWidth () {
      const clientWidth = document.body.clientWidth
      if (clientWidth < 985) {
        this.hiddenCompany = true
        // console.log('监听window窗口变化', clientWidth)
      } else {
        this.hiddenCompany = false
      }
    },

    quit () {
      // 清除token
      sessionStorage.removeItem('access_token')
      this.$store.commit('CLEAR_TOKEN')

      // 跳转路由
      this.$router.push('/login')
    },
    // change password
    resetPasswords () {
      this.title = '修改用户密码'
      this.showUserInfoDialog = true
    },

    // 密码二次确认校验
    validateConfirm (rule, value, callback) {
      const passWord = this.changePwForm.passWord
      if (value !== passWord) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },

    submitForm () {
      //
      this.$refs.changePasswordForm.validate(async valid => {
        if (valid) {
          let res = await update(this.changePwForm)
          // res.code
          console.log('提交', res)
          this.showUserInfoDialog = false
          this.$refs.changePasswordForm.resetFields()
          if (res.code == 0) {
            this.$message({
              message: res.message + ' 请重新登录',
              center: true,
              type: 'success'
            })
            localStorage.setItem('userInfo', JSON.stringify({}))
            this.$router.push('/login')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelChange () {
      this.showUserInfoDialog = false
      this.$refs.changePasswordForm.resetFields()
    },
    fullScreen () {
      this.fullscreenFlag = !this.fullscreenFlag
      const element = document.getElementById('app') // 设置容器全屏
      if (this.fullscreenFlag) {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitFullscreenElement) {
          element.webkitRequestFullScreenElement()
        } else if (element.mozRequestFullScreenElement) {
          element.mozRequestFullScreenElement()
        } else if (element.msRequestFullscreenElement) {
          // IE11
          element.msRequestFullscreenElement()
        }
        element.style.background = '#ececed'
      } else {
        if (document.exitFullScreen) {
          document.exitFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (element.msExitFullscreen) {
          element.msExitFullscreen()
        }
      }
    },
    theme () {
      this.drawer = true
    },

    initTheme () {
      // 初始化默认主题
      if (localStorage.getItem('theme')) {
        const currentTheme = localStorage.getItem('theme')
        setTheme(currentTheme)
        this.radio = currentTheme
      } else {
        setTheme('default')
        this.radio = 'default'
      }
    },

    checkedItem (opts) {
      this.customRadio = ''
      localStorage.removeItem('customTheme')
      if (opts.target.value === 'default') {
        setTheme('default')
      } else if (opts.target.value === 'dark') {
        setTheme('dark')
      } else {
        setTheme('light')
      }
    },

    checkedItem2 (val) {
      this.radio = ''
      this.customRadio = 'custom'
    },
    // 判断是否有自定义主题
    customTheme () {
      const customTheme = localStorage.getItem('customTheme')
      const currentCustomThemeColor = localStorage.getItem(
        'currentCustomThemeColor'
      )
      if (customTheme) {
        this.customRadio = 'custom'
        this.color1 = currentCustomThemeColor
      }
    },

    // 自定义主题
    customPeels (val) {
      this.customRadio = 'custom'
      localStorage.setItem('customTheme', this.customRadio)
      localStorage.setItem('currentCustomThemeColor', val)
      // console.log('选中的颜色', val)
      this.color1 = val
      const rgbValues = extractRGBValues(val)
      if (rgbValues) {
        // rgbValues 处理后的rgb值
        // console.log(rgbValues)
        const newPrimaryColor = `${rgbValues[0]},${rgbValues[1]},${rgbValues[2]}`
        localStorage.setItem('layoutColour', newPrimaryColor) // 将新的主题色存入本地
        setTheme()
        this.radio = null
      }
    },

    closeDialog (newValue) {
      // this.cropperShow = newValue
      this.showUserInfoDialog = false
      this.$refs.changePasswordForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
header {
  height: 56px;
  display: flex;
  justify-content: space-between;
  // color: rgb(@baseColourTextColor);
  // background-color: rgb(@baseColour);
  background-color: #fff;
  color: #7f7f7f;
  border-bottom: 1px solid #ffffff88;
  box-shadow: 0px 5px 5px -5px rgba(150, 150, 150, 0.75);
}
header .headerContainer_left {
  display: flex;
  align-items: center;
}
header .headerContainer_left .el-select {
  flex: 1;
}

header .company-name {
  position: relative;
  // width: 400px;
  height: 100px;
  margin-left: 20px;
  margin-right: 100px;
}

header .company-name p {
  line-height: 100px;
  font-weight: 600;
}

header .company-name img {
  width: 66px;
  height: auto;
}

.orangeTxt {
  color: #f39800;
}

// ::v-deep .el-input__inner {
//   background: transparent;
//   border-color: #536cb5;
//   color: rgb(@baseColourTextColor);
//   border-color: rgba(@baseColourTextColor, 0.5);
// }
header .headerContainer_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: rgba(@baseColourTextColor, 0.6);
}
header .headerContainer_right {
  margin-right: 20px;
}

header .headerContainer_right span,
i {
  padding: 0 10px;
  color: rgba(@baseColourTextColor, 0.6);
}

header .headerContainer_right span {
  padding: 0;
}
header .headerContainer_right i {
  font-size: 18px;
  cursor: pointer;
  background-color: #fff;
  color: #7f7f7f;
}
// header .headerContainer_right i:nth-child(1) {
//   padding: 0 20px;
// }
// header .headerContainer_right i:nth-child(4) {
//   padding-right: 30px;
// }

.el-dropdown-menu {
  top: 70px !important;
}
.el-dropdown .userImg {
  width: 50px;
  height: 50px;
  cursor: pointer;
  vertical-align: middle;
  margin-left: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
}

::v-deep .el-drawer__body {
  padding: 20px;
}

.custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// ::v-deep .el-dialog {
//   background: #001656 !important;
//   box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) !important;
//   border-radius: 10px !important;
//   border: 2px solid rgba(188, 223, 255, 0.4) !important;
//   overflow: hidden;
//   max-width: 656px;
// }

// ::v-deep .el-dialog__body {
//   background-color: #001656;
// }
// ::v-deep .el-dialog__header {
//   background-color: #001656;
//   text-align: left;
//   border: 1px solid #172b65;
//   padding-bottom: 20px;
// }
::v-deep .el-dialog__title {
  color: #333;
  font-weight: 800;
  font-size: 24px;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(var(--baseColourTextColor, green), 0.5);
}
.el-select-dropdown.el-popper .el-select-dropdown__item.selected {
  color: #002592 !important;
}

::v-deep .icon-biyanjing:before,
::v-deep .el-icon-view:before {
  color: #ccc;
}
::v-deep .el-input__suffix {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
